// frontend_pixelmoon/src/components/VipBadge.jsx
import React from "react";

export default function VipBadge({ text, color }) {
  // Helper to determine if we should use dark or light text based on background brightness
  const getContrastColor = (hexColor) => {
    if (!hexColor) return "#fff";

    // Handle standard CSS color names
    const lightNamedColors = [
      "gold",
      "yellow",
      "cyan",
      "white",
      "silver",
      "lightblue",
    ];
    if (!hexColor.startsWith("#")) {
      return lightNamedColors.includes(hexColor.toLowerCase())
        ? "#000000"
        : "#ffffff";
    }

    // Convert hex to RGB
    const hex = hexColor.replace("#", "");
    const r = parseInt(
      hex.length === 3 ? hex[0] + hex[0] : hex.substr(0, 2),
      16,
    );
    const g = parseInt(
      hex.length === 3 ? hex[1] + hex[1] : hex.substr(2, 2),
      16,
    );
    const b = parseInt(
      hex.length === 3 ? hex[2] + hex[2] : hex.substr(4, 2),
      16,
    );

    // Calculate YIQ brightness (WCAG standard approximation)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "#000000" : "#ffffff";
  };

  const bgColor = color || "#8b5cf6";
  const textColor = getContrastColor(bgColor);

  return (
    <span
      style={{
        background: bgColor,
        color: textColor,
        padding: "3px 10px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.02em",
        display: "inline-flex",
        alignItems: "center",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        border:
          textColor === "#000000"
            ? "1px solid rgba(0,0,0,0.1)"
            : "1px solid rgba(255,255,255,0.1)",
      }}
    >
      {text}
    </span>
  );
}
